import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function DigitalDisplaySVG({ value, config = {}, width = 80, height = 40 }) {
    const v = parseFloat(value);
    const decimals = config.decimals ?? 1;
    const unit = config.unit || '';
    const display = isNaN(v) ? '---' : `${v.toFixed(decimals)}${unit}`;
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            <rect x={0} y={0} width={width} height={height} rx={4} fill="#000" stroke="#334155" strokeWidth={1.5} />
            <text
                x={width / 2} y={height / 2 + 5}
                textAnchor="middle"
                fill="#22C55E"
                fontSize={Math.min(16, height * 0.45)}
                fontFamily="monospace"
                fontWeight="bold"
            >
                {display}
            </text>
        </svg>
    );
}

export default function DigitalDisplayNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                <DigitalDisplaySVG value={data?.liveValues?.value ?? data?.liveValue} config={data?.config} width={data?.width || 80} height={data?.height || 40} />
                {data?.label && (
                    <div style={{ fontSize: 10, color: '#94A3B8', marginTop: 2, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                        {data.label}
                    </div>
                )}
            </div>
        </BaseScadaNode>
    );
}
